import React from "react";
import { Facebook, Instagram, Linkedin, Youtube, Twitter, Music2, Globe } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { PinIcon } from "@/components/ShareLinks";

const ICONS: [RegExp, React.ReactNode][] = [
  [/instagram/i, <Instagram className="h-5 w-5" strokeWidth={1.5} />],
  [/facebook/i, <Facebook className="h-5 w-5" strokeWidth={1.5} />],
  [/youtube/i, <Youtube className="h-5 w-5" strokeWidth={1.5} />],
  [/linkedin/i, <Linkedin className="h-5 w-5" strokeWidth={1.5} />],
  [/pinterest/i, <PinIcon />],
  [/twitter|x\.com/i, <Twitter className="h-5 w-5" strokeWidth={1.5} />],
  [/tiktok/i, <Music2 className="h-5 w-5" strokeWidth={1.5} />],
];
const iconFor = (l: any) => ICONS.find(([re]) => re.test(`${l.label} ${l.url}`))?.[1] || <Globe className="h-5 w-5" strokeWidth={1.5} />;

// Footer "Socials" links the admin ticked for articles.
export function FollowLinks() {
  const { site } = useSite();
  const links = (site?.footer_menu || []).filter((c: any) => !c.hidden)
    .flatMap((c: any) => c.links || []).filter((l: any) => l.on_articles && !l.hidden && l.url);
  if (!links.length) return null;
  return (
    <div className="text-center" data-testid="post-follow">
      <p className="eyebrow text-[11px] text-neutral-500 mb-4">Follow Somnio.Co</p>
      <div className="flex justify-center gap-8">
        {links.map((l: any) => (
          <a key={l.url} href={l.url} target="_blank" rel="noreferrer" aria-label={`Follow us on ${l.label}`} title={l.label}
            className="text-neutral-900 hover:text-[var(--c-primary)] transition-colors" data-testid={`post-follow-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{iconFor(l)}</a>
        ))}
      </div>
    </div>
  );
}
